import {TEMP_TOKEN} from './token'
import axios from "axios"
//for development or production just change ip
 export const BASE_URL='http://192.168.1.22:3200/'

// local my laptop dev
//axios.defaults.baseURL = process.env.REACT_APP_LOCAL_BASE_URL_LOCAL;

// LOCAL DEV (LEEYET ERP work) - point at your local erpleeyetadminapi
//axios.defaults.baseURL = 'http://localhost:3004/';

// PRODUCTION BASE URL
axios.defaults.baseURL = 'https://apiadmin.eyeterp.com/';

// PRODUCTION AWS BASE URL
//axios.defaults.baseURL = 'https://apiadminaw.eyeterp.com/';

// PRODUCTION BASE URL UAE
  //  axios.defaults.baseURL=process.env.REACT_APP_PRODUCTION_URL_UAE


// staff section base url for local development
//export const STAFFBASEURL=axios.create({
//  baseURL:'http://192.168.1.55:3200/'
//})

// staff production baseUrl for domain production server uncomment below this line
export const STAFFBASEURL=axios.create({
  baseURL: 'https://apiadmin.eyeterp.com/'
})

// uae production base url
// export const STAFFBASEURL=axios.create({
//   baseURL:'https://aeapitextile.eyeterp.ae'
// })



export const HEADERS={
    headers: {
    "Content-Type": "application/json",
  },
};


export const HEADERS_FORMDATA = {
  headers:{
    "Content-Type": "multipart/form-data",
  }
}

export const HEADER_QUERY = {
  "Content-Type": "application/json",
};